import React from 'react'

import { UniversalImporterItAssetsResultPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterItAssetsResultPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const { loading, error } = useQuery(UniversalImporterItAssetsResultPageDocument, {
    fetchPolicy: 'network-only',
  })

  const canImportResources = true // data?.universalImporter._policies.importResources.can

  return (
    <ResponsivePage.Body
      authorized={canImportResources}
      loading={loading}
      error={error}
      showHeader={false}
    >
      <NuvoImporter
        importType="it_management_it_assets_importer"
        locale={locale}
        companyId={company.id}
      />
    </ResponsivePage.Body>
  )
}

export default UniversalImporterItAssetsResultPage
